import { render } from "./SettingsParams.vue?vue&type=template&id=a11d0112&scoped=true"
import script from "./SettingsParams.vue?vue&type=script&lang=js"
export * from "./SettingsParams.vue?vue&type=script&lang=js"

import "./SettingsParams.vue?vue&type=style&index=0&id=a11d0112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11d0112"]])

export default __exports__